import { PartialTranslation } from '../translations';

export const ne: PartialTranslation = {
  newChat: 'नयाँ च्याट',
  search: 'खोज्नुहोस्',
  user: 'प्रयोगकर्ता',
  settings: 'सेटिङहरू',
  language: 'भाषा',
  getHelp: 'मद्दत पाउनुहोस्',
  viewAllPlans: 'सबै योजनाहरू हेर्नुहोस्',
  learnMore: 'थप जान्नुहोस्',
  logOut: 'लग आउट',
  chooseLanguage: 'भाषा छन्नुहोस्',
  chooseYourPreferredLanguage: 'आफ्नो मनपर्ने भाषा छन्नुहोस्',
  searchLanguages: 'भाषाहरू खोज्नुहोस्...',
  autoDetect: 'स्वचालित पहिचान',
  noLanguagesFound: 'कुनै भाषा फेला परेन',
  askAnything: 'जुनसुकै कुरा सोध्नुहोस्',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'व्यक्तिगत',
  freePlan: 'निःशुल्क योजना',
  current: 'वर्तमान',
  close: 'बन्द गर्नुहोस्',
  archive: 'संग्रहालय',
  delete: 'मेटाउनुहोस्',
  confirmDelete: 'के तपाईं यो च्याट मेटाउन चाहनुहुन्छ?',
  confirmArchive: 'के तपाईं यो च्याट संग्रह गर्न चाहनुहुन्छ?',
  deleteCannotUndo: 'यो कार्य फिर्ता गर्न सकिँदैन।',
  archiveCanFind: 'तपाईंले यसलाई संग्रहालयमा राखेपछि संग्रह सूचीमा फेला पार्न सक्नुहुन्छ।',
  resources: 'स्रोतहरू',
  addResource: 'स्रोत थप्नुहोस्',
  deleteResource: 'स्रोत मेटाउनुहोस्',
  noMatchingResourcesFound: 'कुनै मिल्दो स्रोत फेला परेन',
  noResourcesAvailable: 'कुनै स्रोत उपलब्ध छैन',
  hideResources: 'स्रोतहरू लुकाउनुहोस्',
  showResources: 'स्रोतहरू देखाउनुहोस्',
  typeMessage: 'सन्देश टाइप गर्नुहोस्...',
  thinkingOptions: 'सोच्ने विकल्पहरू',
  deleteFile: 'फाइल मेटाउनुहोस्',
  clearSelection: 'छनोट सफा गर्नुहोस्',
  addAttachment: 'संलग्नक थप्नुहोस्',
  sendMessage: 'सन्देश पठाउनुहोस्',
  deepInsight: 'गहिरो अन्तर्दृष्टि · सतह विश्लेषण',
  deepInsightDesc: 'मुख्य बिन्दुहरूको द्रुत बुझाइ',
  deepExploration: 'गहिरो अन्वेषण · व्यापक विश्लेषण',
  deepExplorationDesc: 'बहुआयामिक गहिरो अनुसन्धान',
  deepDeconstruction: 'गहिरो डिकन्स्ट्रक्शन · व्यवस्थित तर्क',
  deepDeconstructionDesc: 'तह दर तह प्रगतिशील विश्लेषण',
  contractReview: 'अनुबन्ध समीक्षा · जोखिम पहिचान',
  contractReviewDesc: 'खण्ड विश्लेषण र अनुपालन जाँच',
  textPolish: 'पाठ पालिसिङ · व्यावसायिक अभिव्यक्ति',
  textPolishDesc: 'भाषा अनुकूलन र संरचना समायोजन',
  legalDocuments: 'कानुनी दस्तावेजहरू · मानक मस्यौदा',
  legalDocumentsDesc: 'व्यावसायिक कानुनी दस्तावेज लेखन',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'लग इन',
  register: 'दर्ता',
  welcomeBack: 'LawHelper मा स्वागत छ',
  loginSubtitle: 'तपाईंको AI कानूनी अनुसन्धान सहायक',
  continueWithGoogle: 'Google मार्फत जारी राख्नुहोस्',
  continueWithMicrosoft: 'Microsoft मार्फत जारी राख्नुहोस्',
  continueWithWeChat: 'WeChat मार्फत जारी राख्नुहोस्',
  orContinueWith: 'वा यससँग जारी राख्नुहोस्',
  emailTab: 'इमेल',
  phoneTab: 'फोन',
  emailPlaceholder: 'तपाईंको इमेल प्रविष्ट गर्नुहोस्',
  phonePlaceholder: 'फोन नम्बर प्रविष्ट गर्नुहोस्',
  codePlaceholder: '६ अंकको कोड प्रविष्ट गर्नुहोस्',
  sending: 'पठाउँदै...',
  verifying: 'प्रमाणित गर्दै...',
  verify: 'प्रमाणित गर्नुहोस्',
  sendMagicLink: 'जादुई लिंक पठाउनुहोस्',
  getVerificationCode: 'कोड प्राप्त गर्नुहोस्',
  resendCode: 'कोड पुन: पठाउनुहोस्',
  resendIn: 'पुन: पठाउनुहोस्',
  magicLinkSent: 'जादुई लिंक तपाईंको इमेलमा पठाइयो',
  magicLinkHint: 'हामी तपाईंको इमेलमा सुरक्षित लिंक पठाउनेछौं',
  otpSent: 'प्रमाणीकरण कोड पठाइयो',
  agreeToTerms: 'जारी राखेर, तपाईं सहमत हुनुहुन्छ',
  privacyPolicy: 'गोपनीयता नीति',
  termsOfService: 'सेवाका सर्तहरू',
  and: 'र',
  privacyTitle: 'तपाईंको गोपनीयता महत्त्वपूर्ण छ',
  privacyIntro: 'हामी उत्तम अनुभव प्रदान गर्न कुकीज र समान प्रविधिहरू प्रयोग गर्छौं।',
  essentialCookies: 'आवश्यक कुकीज',
  essentialDesc: 'वेबसाइट काम गर्न आवश्यक',
  analyticsCookies: 'विश्लेषण कुकीज',
  analyticsDesc: 'सेवा सुधार गर्न मद्दत गर्छ',
  marketingCookies: 'मार्केटिङ कुकीज',
  marketingDesc: 'व्यक्तिगत सामग्रीको लागि प्रयोग गरिन्छ',
  acceptAll: 'सबै स्वीकार गर्नुहोस्',
  essentialOnly: 'आवश्यक मात्र',
  customize: 'अनुकूलन गर्नुहोस्',
  savePreferences: 'प्राथमिकताहरू सुरक्षित गर्नुहोस्',
  back: 'पछाडि',
  readPrivacyPolicy: 'हाम्रो गोपनीयता नीति पढ्नुहोस्',
  cookiePolicy: 'कुकी नीति',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI समीक्षा',
  aiDraft: 'AI ड्राफ्ट',
  smartAssistant: 'टेम्प्लेट',

  // 知识库搜索
  enableKnowledgeSearch: 'खोज सक्षम गर्नुहोस्',
  knowledgeSearchDesc: 'AI तपाईंको कागजातहरूमा खोज्छ',
  clickToDisable: 'असक्षम',
  clickToEnable: 'सक्षम',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'छिटो उत्तर',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'रद्द गर्नुहोस्',
  library: 'पुस्तकालय',
  filterAll: 'सबै',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'सोचिरहेको छ...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'सामान्य',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'बारेमा',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'स्मार्ट दस्तावेज सहायक',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'त्रुटि',
  unknownError: 'Unknown error',
  file: 'फाइल',
  loading: 'लोड हुँदैछ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI विश्लेषण',
};
